"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleFormValidator = void 0;
const echain_shared_form_validation_1 = require("@igus/echain-shared-form-validation");
/**
 * Validators that can be used for most articles.
 */
class ArticleFormValidator {
    static anzahl(options) {
        return echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 0,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0,
        });
    }
}
exports.ArticleFormValidator = ArticleFormValidator;
//# sourceMappingURL=ArticleFormValidator.js.map